import * as React from "react";

import { User, Permission } from "./api/auth";

type UserContextType = {
  user: User | null;
  setUser: (user: User | null) => void;
};

const UserContext = React.createContext({} as UserContextType);

export function UserProvider({ children }: { children: any }) {
  const [user, setUser] = React.useState<User | null>(null);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = React.useContext(UserContext);

  const user = context.user!;

  return {
    hasPermission: (requiredPermissions: Permission[]) => {
      return requiredPermissions.every(requiredPermission =>
        user.permissions.includes(requiredPermission)
      );
    },
    canMutateLanguage: (language: string) => {
      if (user.languages[0] === "*") {
        return true;
      }

      return user.languages.some(lang => lang === language);
    },
    user,
    setUser: context.setUser
  };
}
